import { FormControl, Grid, Select, Table, TableBody, TableCell, TableRow
    , TextField, Typography, IconButton, Tooltip, InputLabel, Box } from '@mui/material'
import { AddCircle as IconAddCircle, Delete as IconDelete } from "@mui/icons-material";
import api from "../../services/api";
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    addPersonaDocumento, removePersonaDocumento, setDatoPersonaDocumento
    , setPersonaDocumentos, setTiposDocumentos, setValidations, initPersonDocument, defaultPersonaDocumentos, defaultPersonaJuridicaDocumentos
} from '../../redux/person/personDocumentSlice'
import DialogYesNo from '../common/DialogYesNo'
import { FormHelperText as HelperText } from '@mui/material';
import * as personaService from "../../services/personaService";
import * as catalogoService from "../../services/catalogoService";

const PersonDocument = (props) => {
    const dispatch = useDispatch();
    const sliceKey = props.sliceKey;
    const isReadOnly = props.isReadOnly;

    useEffect(() => {
        dispatch(initPersonDocument({ sliceKey }));
    }, [dispatch, sliceKey]);

    const personaDocumentos = useSelector((state) => state.personDocument[sliceKey]?.personaDocumentos)
    const tiposDocumentos = useSelector((state) => state.personDocument[sliceKey]?.tiposDocumentos)
    const validate = useSelector((state) => state.personDocument[sliceKey]?.validationActive);

    const [openDialogDelete, setOpenDialogDelete] = useState(false)
    const openCloseDialogDelete = () => { setOpenDialogDelete(!openDialogDelete); }
    const [selectNumero, setSelectNumero] = useState(null);
    const [selectId, setSelectId] = useState(null);
    const [numeroDocumentoFocus, setNumeroDocumentoFocus] = useState(null);
    const [numeroDocumentoExistente, setNumeroDocumentoExistente] = useState(false);
    const [typeDocumentAlReadyExists, setTypeDocumentAlReadyExists] = useState("");

    const validation = useMemo(() => {
        const duplicateTypes = new Set((personaDocumentos || []).map(d => d.idTipoDocumento)).size !== (personaDocumentos || []).length;
        const dniInvalid = (personaDocumentos || []).some(d => Number(d.idTipoDocumento) === 6 && d.numeroDocumento?.length !== 8);
        // Solo valida la longitud cuando el numero esta escrito; si esta vacio
        // AtLeastOneDocument ya se encarga de avisar que falta el documento.
        const rucInvalid = (personaDocumentos || []).some(d =>
            Number(d.idTipoDocumento) === 7 && !!d.numeroDocumento && d.numeroDocumento.length !== 11
        );
        const documentTooShort = (personaDocumentos || []).some(d => d.idTipoDocumento > 0 && d.numeroDocumento?.length < 3);
        
        return {
            AtLeastOneDocument: {
                error: (personaDocumentos || []).length === 1 && (personaDocumentos[0].idTipoDocumento === 0 || !personaDocumentos[0].numeroDocumento),
                message: "Debe haber por lo menos un documento"
            },
            OnlyOneTypeDocument: {
                error: duplicateTypes,
                message: "Sólo puede existir 1 de cada tipo de documento"
            },
            DNIWith8Digits: {
                error: dniInvalid,
                message: "El DNI debe tener 8 dígitos"
            },
            RUCWith11Digits: {
                error: rucInvalid,
                message: "El RUC debe tener 11 dígitos"
            },
            AnyDocumentAtLeast3Digits: {
                error: documentTooShort,
                message: "Un documento debe tener por lo menos 3 dígitos"
            },
            DocumentAlReadyExists: {
                error: numeroDocumentoExistente,
                message: `El número de documento ${typeDocumentAlReadyExists} ya existe`
            }
        };
    }, [
        personaDocumentos,
        numeroDocumentoExistente,
        typeDocumentAlReadyExists
    ]);

    const setItemValue = (numero, name, value) => {
        dispatch(setDatoPersonaDocumento({sliceKey: sliceKey, numero: numero, name: name, value: value}))
    }

    const fetchPersonaDocumentos = useCallback(async () => {
        const response = await personaService.getsPersonaDocumentoView(props.id);
        if (response == null || response.length == 0)
            dispatch(setPersonaDocumentos({sliceKey: sliceKey, data: sliceKey == "personEditLegal" ? defaultPersonaJuridicaDocumentos : defaultPersonaDocumentos}));
        else
            dispatch(setPersonaDocumentos({sliceKey: sliceKey, data: response}));
    }, [dispatch, sliceKey, props.id])

    const fetchTiposDocumentos = useCallback(async () => {
        const response = await catalogoService.getCatalogosByPadre(5)
        dispatch(setTiposDocumentos({sliceKey: sliceKey, data: response}));
    }, [])

    useEffect(() => {
        fetchPersonaDocumentos();
        fetchTiposDocumentos();
    }, [fetchPersonaDocumentos, fetchTiposDocumentos])

    const validateDocuments = (documents) => {
        const errors = [];

        if (documents.length === 1 && (documents[0].idTipoDocumento === 0 || !documents[0].numeroDocumento))
            errors.push("Debe haber por lo menos un documento");

        const typeIds = documents.map(x => x.idTipoDocumento).filter(x => x > 0);

        if (new Set(typeIds).size !== typeIds.length)
            errors.push("Sólo puede existir 1 de cada tipo de documento");

        documents.forEach(doc => {
            const numero = doc.numeroDocumento || "";

            if (doc.idTipoDocumento > 0 && numero && numero.length < 3)
                errors.push("Un documento debe tener por lo menos 3 dígitos");

            if (Number(doc.idTipoDocumento) === 6 && numero && numero.length !== 8)
                errors.push("El DNI debe tener 8 dígitos");

            if (Number(doc.idTipoDocumento) === 7 && numero && numero.length !== 11)
                errors.push("El RUC debe tener 11 dígitos");
        });

        return [...new Set(errors)];
    };

    const validationMessages = useMemo(() => {
        return validateDocuments(personaDocumentos ?? []);
    }, [personaDocumentos]);

    const prevValidationMessages = React.useRef()

    useEffect(() => {
        if (JSON.stringify(prevValidationMessages.current) !== JSON.stringify(validationMessages)) {
            prevValidationMessages.current = validationMessages
            dispatch(setValidations({
                sliceKey,
                message: validationMessages
            }))
        }
    }, [dispatch, sliceKey, validationMessages])

    const deletePersonaDocumento = async () => {
        await personaService.deletePersonaDocumento(props.id, selectNumero)
        dispatch(removePersonaDocumento({sliceKey: sliceKey, numero: selectNumero}));
    }
    const buscarDocumentoExistente = async (idTipoDocumento, numeroDocumento) => {
        const document = await personaService.getsPersonaDocumentoByTipoYNumeroView(idTipoDocumento, numeroDocumento)
        setNumeroDocumentoExistente(document.length > 0);
    }

    return (
        <Grid container>
            <Grid item>
                <Typography variant="h7">
                    <Box sx={{ fontWeight: 'bold' }} padding={0}>
                        {"Documentos (" + (personaDocumentos?.length || 0) + ")"}
                    </Box>
                </Typography>
            </Grid>
            <Grid item>
                <Tooltip title={"Agregar Dirección"}>
                    <IconButton size="small" aria-label="Agregar Direccion" style={{height: 10}} disabled={isReadOnly} onClick={() => {
                        dispatch(addPersonaDocumento(sliceKey));
                    }}>
                        <IconAddCircle />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Grid container>
                {/* {JSON.stringify(validation)} */}
                <Table size="small">
                    <TableBody>
                        {personaDocumentos?.map((row, index) => (
                            <TableRow key={row.numero} sx={(theme) => ({
                                backgroundColor: index % 2 === 1 ? theme.palette.action.selected : 'inherit',
                                "&:last-child td, &:last-child th": { borderRadius: "0.5em" },
                            })}>
                                <TableCell>
                                    <Grid container spacing={1} padding={0}>
                                        <Grid item xs={8} sm={5}>
                                            <FormControl required fullWidth>
                                                <InputLabel htmlFor="input-tipodocumento">Tipo</InputLabel>
                                                <Select
                                                    native
                                                    label="Tipo"
                                                    value={row.idTipoDocumento || 0}
                                                    fullWidth
                                                    onChange={(event, newValue) => {
                                                        if (event.target.value !== row.idTipoDocumento && row.numeroDocumento != null && row.numeroDocumento.length >= 6) {
                                                            buscarDocumentoExistente(event.target.value, row.numeroDocumento)
                                                        }

                                                        if (event.target.value == 0){
                                                            setNumeroDocumentoExistente(false)
                                                        }

                                                        var id = event.nativeEvent.target.selectedIndex;

                                                        setItemValue(row.numero, "idTipoDocumento", event.target.value)
                                                        setItemValue(row.numero, "tipoDocumento", event.nativeEvent.target[id].text)

                                                            // Al cambiar a RUC se limpian los digitos incompatibles con los 11 requeridos.
                                                            if (Number(event.target.value) === 7 && row.numeroDocumento?.length > 11) {
                                                                setItemValue(row.numero, "numeroDocumento", "")
                                                            }
                                                    }}
                                                    inputProps={{
                                                        name: 'idTipoDocumento',
                                                        id: 'input-tipodocumento',
                                                    }}
                                                    size="small"
                                                    disabled={isReadOnly}
                                                >
                                                    <option key={0} value={0}>{"(Seleccione)"}</option>
                                                    {tiposDocumentos.map((row) => (
                                                        <option key={row.id} value={row.id}>{row.descripcion}</option>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={7}>
                                            <Box display="flex" alignItems="center" gap={0}>
                                                <TextField
                                                    required
                                                    name="numeroDocumento"
                                                    label="Numero"
                                                    value={row.numeroDocumento || ""}
                                                    inputProps={{
                                                        maxLength: Number(row.idTipoDocumento) === 7 ? 11 : undefined,
                                                    }}
                                                    error={Number(row.idTipoDocumento) === 7
                                                        && !!row.numeroDocumento
                                                        && row.numeroDocumento.length !== 11}
                                                    helperText={Number(row.idTipoDocumento) === 7
                                                        && !!row.numeroDocumento
                                                        && row.numeroDocumento.length !== 11
                                                        ? "El RUC debe tener 11 dígitos" : ""}
                                                    fullWidth
                                                    onFocus={(event) => {
                                                        setNumeroDocumentoFocus(event.target.value)
                                                    }}
                                                    onChange={(event) => {
                                                        setItemValue(row.numero, "numeroDocumento", event.target.value)
                                                        setNumeroDocumentoExistente(false)
                                                    }}
                                                    onBlur={(event) => {
                                                        if (row.idTipoDocumento > 0 && event.target.value.length >= 6 && event.target.value !== numeroDocumentoFocus) {
                                                            setTypeDocumentAlReadyExists(row.tipoDocumento)
                                                            buscarDocumentoExistente(row.idTipoDocumento, event.target.value)
                                                        }
                                                        else {
                                                            if (event.target.value.length < 6) setNumeroDocumentoExistente(false)
                                                        }

                                                        setItemValue(row.numero, "numeroDocumento", event.target.value)
                                                    }}
                                                    size="small"
                                                    disabled={isReadOnly}
                                                />
                                                <Tooltip title={"Borrar Documento"} arrow>
                                                    <IconButton aria-label="delete" disabled={isReadOnly} onClick={() => {
                                                        if (row.idPersona > 0) {
                                                            setSelectId(row.id);
                                                            setSelectNumero(row.numero);
                                                            setOpenDialogDelete(true);
                                                        }
                                                        else {
                                                            dispatch(removePersonaDocumento({sliceKey: sliceKey, numero: row.numero}));
                                                        }

                                                    }}>
                                                        <IconDelete />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <FormControl required fullWidth
                    error={
                        Object.keys(validation).some(
                            key => validate?.[key] && validation[key].error
                        )
                    }
                >
                    {Object.keys(validation).map(key => (
                        validate?.[key] && validation[key].error && (
                            <HelperText key={key}>
                                {validation[key].message}
                            </HelperText>
                        )
                    ))}
                </FormControl>
            </Grid>
            <DialogYesNo
                open={openDialogDelete}
                openClose={openCloseDialogDelete}
                setYes={deletePersonaDocumento}
                setNo={() => { return }}
                titulo={"Borrar Documento"}
                texto={"Esta seguro de borrar el documento?"}
            ></DialogYesNo>
        </Grid>
    )
}

export default PersonDocument;
